import React from 'react';
import {Typography} from 'material-ui';
import {SelectMultiple} from '../../../components/fields/field_multi_select';

class MetaLandingFields extends React.Component {
    render() {
        let {
            allProducts,
            selectedProducts,
            updatePageMetaLandingProducts,
        } = this.props;

        return (
            <div>
                <Typography variant="caption" style={{marginBottom: 5}}>
                    Select Products from the drop-down
                </Typography>
                <SelectMultiple
                    id="products"
                    label={'Select Products'}
                    name="products"
                    onItemsChange={(items) => {
                        updatePageMetaLandingProducts(items);
                    }}
                    selectedItems={selectedProducts}
                    items={allProducts}
                    labelKey={'display_name'}
                    valueKey={'id'}
                />
            </div>
        );
    }
}

export default MetaLandingFields;



// WEBPACK FOOTER //
// ./src/containers/builder/form/meta_landing_fields.js